import '@carwow/carwow_theme/app/javascript/components/make_model_menu'

document.addEventListener('DOMContentLoaded', () => {
  if (window.Carwow && window.Carwow.registerBugsnagVolumeError) {
    window.Carwow.registerBugsnagVolumeError((error) => {
      const component = error.errorClass.includes('carwow-make-model-menu')
      const messages = ['Http.Timeout']
      const validError = messages.some(message => error.errorMessage.includes(message))

      return component && validError
    })
  }
})
